if (!window.hasOwnProperty('coreModules')) {
    window.coreModules = {};
}

window.coreModules.User = function() {
    var self = this;
    self.data =  {};
    self.sync = [];
    var sending = false;

    self.set = function(data) {
        self.data = data;
    };

    function sync() {
        for (var i in self.sync) {
            self.sync[i]();
        }
    }

    function logout(cb) {
        if (!sending) {
            sending = true;
            $.post('/api/users/logout', function (response) {
                sending = false;
                if (response.hasOwnProperty('error')) {
                    self.dialog.show('message', {message: response.error});
                } else {
                    self.data = {};
                    sync();
                    cb();
                }
            }, 'json');
        }
    }

    $(document).on('click', '.logout-user', function() {
        logout(function() {
            $('.login-user').removeClass('hide');
            $('.user-module').addClass('hide');
        });
    });
};
